import styled from '@emotion/styled'

export const InnerContainner = styled.div`
  padding: 30px 85px 30px 30px;
  border-bottom: 1px solid #eaedf3;
  color: #3e3f42;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const SubTitle = styled.h3`
  font-size: 16px;
  color: #3e3f42;
`

export const Text = styled.p`
  font-size: 14px;
  color: #3e3f42;
`

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-right: 20px;
`

export const StyledForm = styled.form`
  display: flex;
  align-items: center;
  width: 80%;
  justify-content: flex-end;
`

export const FirstField = styled.div`
  padding-right: 30px;
`

export const ErrorStyle = styled.span`
  color: #e6492d;
  font-size: 0.75rem;
`
